import { render, staticRenderFns } from "./qy-dialog.vue?vue&type=template&id=8ed96c72&scoped=true"
import script from "./qy-dialog.vue?vue&type=script&lang=js"
export * from "./qy-dialog.vue?vue&type=script&lang=js"
import style0 from "./qy-dialog.vue?vue&type=style&index=0&id=8ed96c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ed96c72",
  null
  
)

export default component.exports